import Tree from './src/tree.mjs';

Tree.install = (app) => {
  app.component(Tree.name, Tree);
};
const _Tree = Tree;
const ElTree = _Tree;

export { ElTree, _Tree as default };
//# sourceMappingURL=index.mjs.map
